export default {
    backButton: {
        id: 'MEDCAL_RX_BACK_BUTTON',
        defaultMessage: 'Back',
    }
};
